﻿import { FIQAssist } from "../app";
import { Component, Input, Output, Inject, Attribute, OutputArgs } from "@fiqas/angular-utils";

@Component({
    module: FIQAssist,
    selector: 'fqtextarea',
    template: `<div class="fqtextarea fixchild ng-class:{hasfocus:$ctrl.hasfocus,'has-value': $ctrl.hasValue, error: $ctrl.showError, readonly:$ctrl.readOnly}">
                <div class="placeholder">
                  <span class="placeholder-text unselectable" ng-hide="$ctrl.hasValue" ng-click="$ctrl.focusTextarea()">{{$ctrl.hint | translate}}</span>
                  <textarea rows="1" ng-readonly="$ctrl.readOnly" class="textarea" type="text" ng-change="$ctrl.onChange($event)" ng-model="$ctrl.value" ng-focus="$ctrl.onFocus()" ng-blur="$ctrl.onBlur()"></textarea>
                </div>
                <span class="mandatory-dot" ng-if="$ctrl.mandatory" uib-tooltip="{{'FIELD_REQUIRED_TOOLTIP' | translate}}" tooltip-placement="{{$ctrl.tooltipPlacement ? $ctrl.tooltipPlacement : 'bottom'" tooltip-class="customTooltipTB"></span>
                <div ng-show="$ctrl.candelete" ng-click="$ctrl.ClearField()" class="clearfield-icon" uib-tooltip="{{'DELETE_CHAT_TOOLTIP' | translate}}" tooltip-placement="{{$ctrl.tooltipPlacement ? $ctrl.tooltipPlacement : 'bottom'" tooltip-class="customTooltipTB">
                      <span class="icon-clearField"></span>
                </div>
            </div>`
})
export class Autosize {
    constructor(
        @Inject('$window') private $window: angular.IWindowService,
        @Inject('$element') private $element: angular.IRootElementService,
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject('$scope') private $scope: angular.IScope,
        @Inject('hotkeys') private hotkeys: ng.hotkeys.HotkeysProvider
    ) {
        this.$element.on('keypress', () => this.ajustDynamicHTMLLayout());

        hotkeys.bindTo($scope);
        this.hotkey = [this.undoHotkeys = {
            combo: ['ctrl+z'],
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            callback: (e) => {
                this.resetValue(e);
            }
        }];

    }
    @Input() public tooltipPlacement: string;
    @Input() public readOnly: boolean;
    @Input() public candelete: boolean;

    $postLink() {
        this.ajustDynamicHTMLLayout();
    }

    @Output() public onLayoutReset;
    @Output() public onLayoutAjust: OutputArgs<{ height: number }>;
    public async ajustDynamicHTMLLayout() {
        await this.$timeout();
        var element = this.$element;
        var ta1 = (<any>element[0].getElementsByClassName('textarea').item(0));
        var oldHieght: number = ta1.clientHeight;
        ta1.style.height = this.minHeight
        ta1.style.height = `${(ta1.scrollHeight <= this._minHeightNumeric) ? this._minHeightNumeric : (ta1.scrollHeight >= this._maxHeightNumeric) ? this._maxHeightNumeric : ta1.scrollHeight}px`;
        if (ta1.scrollHeight > ta1.clientHeight && (!ta1.style.overflowY || ta1.style.overflowY != "scroll")) {
            ta1.style.overflowY = "scroll";
        }
        if (ta1.scrollHeight <= this._maxHeightNumeric && (!ta1.style.overflowY || ta1.style.overflowY != "hidden")) {
            ta1.style.overflowY = "hidden"
        }
        if (this.onLayoutAjust && oldHieght === ta1.clientHeight) this.onLayoutAjust({ height: ta1.clientHeight });
    }

    private hotkey: ng.hotkeys.Hotkey[];
    private undoHotkeys: ng.hotkeys.Hotkey;

    private _previousValue: string;
    private _textareaCleared: boolean = false;
    private _minHeight: string;
    private _minHeightNumeric: number;
    private get minHeight(): string {
        return this._minHeight;
    }
    private set minHeight(val: string) {
        this._minHeight = val;
        this._minHeightNumeric = Number(val.replace(/[^\d]/g, ""));
    }
    private _maxHeight: string;
    private _maxHeightNumeric: number;
    private get maxHeight(): string {
        return this._maxHeight;
    }
    private set maxHeight(val: string) {
        this._maxHeight = val;
        this._maxHeightNumeric = Number(val.replace(/[^\d]/g, ""));
    }
    private _mandatory;
    @Attribute() public get mandatory() {
        return this._mandatory;
    }
    public set mandatory(val: boolean | string) {
        this._mandatory = val === true || val === "true";
    }
    private get hasValue() {
        return this._value !== null && this._value !== undefined && this._value !== "";
    }

    private get showError() {
        return this.mandatory && ((!this.hasfocus && this.wasFocused && !this.hasValue) || (!this.hasfocus && this.iserror));
    }
    async $onInit() {
        var element = this.$element;
        if (this.focusinput) {
            await this.$timeout();
            (<any>(element[0].getElementsByClassName('textarea').item(0))).focus();
        }
        var ta1 = (<any>element[0].getElementsByClassName('textarea').item(0));
        this.minHeight = this.$window.getComputedStyle(ta1).minHeight || "24px";
        this.maxHeight = this.$window.getComputedStyle(ta1).maxHeight || "24px";
        ta1.style.minHeight = this._minHeight;
        ta1.style.maxHeight = this._maxHeight;
        ta1.style.overflow = "hidden";

        this.hotkey.forEach(key => {
            this.hotkeys.add(key);
        });

    }

    $onDestroy() {
        this.hotkey.forEach(key => {
            this.hotkeys.del(key.combo);
        });
    }

    private getTextarea() {
        const element = this.$element;
        return (<any>element[0].getElementsByClassName('textarea').item(0));
    }

    private focusTextarea() {
        const textarea = this.getTextarea();
        textarea.focus();
        return textarea;
    }

    private _value: string = "";
    @Input() public get value(): string {
        return this._value;
    }
    public set value(val: string) {
        if (val !== this._value) {
            this._value = val;
            this.onvaluechanged({ value: val });
        }
        this.ajustDynamicHTMLLayout();
    }

    @Input() public hint: string;
    @Input() public iserror: boolean;
    @Input() public focusinput: boolean;
    @Output() public onvaluechanged: (args: { value: string }) => void;

    private hasfocus: boolean = false;
    private wasFocused: boolean = false;
    private onFocus() {
        this.hasfocus = this.wasFocused = true;
        this.ajustDynamicHTMLLayout();
    }

    private onChange() {
        if (this._textareaCleared) {
            const textarea = this.getTextarea();
            if (textarea.selectionStart !== textarea.selectionEnd) {
                const length = (this.value) ? this.value.length : 0;
                textarea.selectionStart = length;
                textarea.selectionEnd = length;
            }
        }
    }

    private onBlur() {
        this.hasfocus = false;
        if (this.onLayoutReset) this.onLayoutReset();
    }

    public ClearField() {
        if (this.readOnly || !this.candelete)
            return;

        this._previousValue = this._value;
        // This method is not correctly sipported by Firefox, so we fake a undo.
        // const textarea = this.focusTextarea();
        // textarea.select();
        // document.execCommand('delete');
        this._textareaCleared = true;
        this.value = '';
        this.onvaluechanged({ value: this._value });
    }

    private resetValue(event) {
        if (this._previousValue) {
            this.value = this._previousValue;
            this._previousValue = '';
        }
    }
}
